module.exports = __webpack_public_path__ + "static/media/main.ea02ea54.png";